<template>
  <div>
    <section class="box-detail form-detail">
      <h1>Thông tin MC</h1>
      <div class="form-group form-row">
        <label class="col-sm-3 col-form-label"
          >Tên Merchant <span class="float-right">:</span></label
        >
        <div class="col-sm-9">
          <p class="form-control-plaintext f12">
            {{ customerInfo ? customerInfo.merchantName : 'Không có' }}
          </p>
        </div>
      </div>
      <div
        class="form-group form-row"
        v-if="customerInfo && customerInfo.customerType === 'COMPANY'"
      >
        <label class="col-sm-3 col-form-label">MST/ ĐKKD<span class="float-right">:</span></label>
        <div class="col-sm-9">
          <p class="form-control-plaintext f12">
            {{ customerInfo ? customerInfo.businessRegistrationNumber : '' }}
          </p>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-3 col-form-label">Email<span class="float-right">:</span></label>
        <div class="col-sm-9">
          <p class="form-control-plaintext f12">
            {{ customerInfo ? customerInfo.email : 'Không có' }}
          </p>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-3 col-form-label"
          >Số điện thoại<span class="float-right">:</span></label
        >
        <div class="col-sm-9">
          <p class="form-control-plaintext f12">
            {{ customerInfo ? customerInfo.mobile : 'Không có' }}
          </p>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-3 col-form-label">Địa chỉ<span class="float-right">:</span></label>
        <div class="col-sm-9">
          <p class="form-control-plaintext f12">
            {{ customerInfo ? customerInfo.address : 'Không có' }}
            <!-- ,
            {{ customerInfo ? customerInfo.district : "Không có" }},
            {{ customerInfo ? customerInfo.city : "Không có" }} -->
          </p>
        </div>
      </div>
      <div class="form-group form-row" v-if="customerInfo && customerInfo.businessFieldAmount">
        <label class="col-sm-3 col-form-label"
          >Giá trị trung bình<span class="float-right">:</span></label
        >
        <div class="col-sm-9">
          <p class="form-control-plaintext f12">
            {{ customerInfo.businessFieldAmount | transformNumber }}
          </p>
        </div>
      </div>
    </section>

    <section class="box-detail form-detail">
      <h1>Thông tin hợp đồng</h1>
      <div class="form-group form-row">
        <label class="col-sm-3 col-form-label"
          >Số hợp đồng <span class="float-right">:</span></label
        >
        <div class="col-sm-8">
          <p class="form-control-plaintext f12">
            {{ dataContract.code ? dataContract.code : 'Không có' }}
          </p>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-3 col-form-label">Loại<span class="float-right">:</span></label>
        <div class="col-sm-8">
          <p class="form-control-plaintext f12">
            {{ dataContract.typeCustomer | fomatCustomtype }}
          </p>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-3 col-form-label">Dịch vụ<span class="float-right">:</span></label>
        <div class="col-sm-8">
          <p
            v-for="(data, index) in dataContract.serviceTypes"
            :key="index"
            class="form-control-plaintext f12"
          >
            {{ data | serviceTypes }}
          </p>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-3 col-form-label">Ngày ký<span class="float-right">:</span></label>
        <div class="col-sm-8">
          <p class="form-control-plaintext f12">
            {{
              dataContract.effectiveFromDTO
                ? dataContract.effectiveFromDTO
                : dataContract.dateSign | formatDate
            }}
          </p>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-3 col-form-label">Mô tả<span class="float-right">:</span></label>
        <div class="col-sm-8">
          <p class="form-control-plaintext f12">
            {{ dataContract.description }}
          </p>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-3 col-form-label">Trạng thái<span class="float-right">:</span></label>
        <div class="col-sm-8">
          <p class="form-control-plaintext f12">
            <span class="badge" v-bind:class="[dataContract.state ? dataContract.state : '']">{{
              dataContract.state | mapTextStatus(listStatusContract)
            }}</span>
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  export default {
    props: ['dataContract'],
    data() {
      return {
        listStatusContract: Config.listStatusContract,
      }
    },
    filters: {
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
